import Axios from 'axios'
import Config from '@/Config'
import FetcherHelper from '@/helpers/FetcherHelper'

export default class Contact {
  constructor () {
    this.id = 0
    this.companyName = ''
    this.address = ''
    this.zip = ''
    this.city = ''
    this.firstName = ''
    this.lastName = ''
    this.phone = ''
    this.email = ''
  }

  static setPrototype (obj) {
    Object.setPrototypeOf(obj, Contact.prototype)
    return obj
  }

  static get apiBaseUrl () {
    return `${Config.apiBaseUrl}/form/contact`
  }

  static list () {
    return new Promise((resolve, reject) => {
      Axios.get(Contact.apiBaseUrl, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(response.data.map(d => Contact.setPrototype(d)))
        }).catch(reject)
    })
  }

  static get (id) {
    return new Promise((resolve, reject) => {
      Axios.get(`${Contact.apiBaseUrl}/${id}`, FetcherHelper.getHeaders())
        .then((response) => {
          resolve(Contact.setPrototype(response.data))
        }).catch(reject)
    })
  }

  save () {
    return new Promise((resolve, reject) => {
      if (this.id === 0) {
        // Create
        Axios.post(Contact.apiBaseUrl, this, FetcherHelper.getHeaders())
          .then((response) => {
            resolve()
          }).catch(reject)
      } else {
        // update
        Axios.put(`${Contact.apiBaseUrl}/${this.id}`, this, FetcherHelper.getHeaders())
          .then((response) => {
            resolve()
          }).catch(reject)
      }
    })
  }

  delete () {
    return Axios.delete(`${Contact.apiBaseUrl}/${this.id}`, FetcherHelper.getHeaders())
  }
}
